module.exports = __webpack_public_path__ + "static/google-adwords-c6b848ec1ddbfc2481cb2682574c4072.png";